import React from 'react';
import UserAvatar from 'components/pure/utils/UserAvatar';
import './UserOptions.styl';
import classNames from 'classnames';

export default class UserOptions extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hoveredIdx: null,
    };
    this.handleKeyShortcut = this.handleKeyShortcut.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyShortcut, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyShortcut, false);
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({hoveredIdx: null});
    }
  }

  handleKeyShortcut(e) {
    const {hoveredIdx} = this.state;
    const {users} = this.props;

    if (e.key === 'ArrowDown') {
      e.preventDefault();

      let newIdx = null;
      if (hoveredIdx === null || hoveredIdx === users.size - 1) {
        newIdx = 0;
      } else {
        newIdx = hoveredIdx + 1;
      }

      this.setState({hoveredIdx: newIdx});
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();

      let newIdx = null;
      if (hoveredIdx === null || hoveredIdx === 0) {
        newIdx = users.size - 1;
      } else {
        newIdx = hoveredIdx - 1;
      }

      this.setState({hoveredIdx: newIdx});
    } else if (e.key === 'Enter') {
      if (hoveredIdx !== null) {
        e.preventDefault();
        this.props.onSelect(users.get(hoveredIdx));
      }
    } else if (e.key === 'Escape') {
      this.props.onCancel();
    }
  }

  render() {
    const {users} = this.props;
    const {hoveredIdx} = this.state;
    if (!users) {
      return null;
    }
    if (users.size === 0) {
      return <div className="user-options no-matches">No users match the search term.</div>;
    }
    return (
      <div className="user-options">
        {users.map((user, idx) => (
          <div
            key={user.id}
            className={classNames(['user-option-row', idx === hoveredIdx && 'hover'])}
            onMouseOver={() => this.setState({hoveredIdx: idx})}
            onMouseOut={() => this.setState({hoveredIdx: null})}
            onClick={() => this.props.onSelect(user)}>
            <UserAvatar user={user} />
            {user.getFullName()}
          </div>
        ))}
      </div>
    );
  }
}
